import { memo, useEffect, useRef, useState } from 'react';

const padDex = (num) => `#${String(num).padStart(3, '0')}`;

// Single binder slot. Search dim/ring styling lives on the parent wrapper
// so memoization holds while the user types.
const DexSlot = memo(({ num, name, entry, onEmptyClick, onRemove }) => {
  const [imgError, setImgError] = useState(false);
  const [confirmingRemove, setConfirmingRemove] = useState(false);
  const confirmTimer = useRef(null);

  useEffect(() => () => clearTimeout(confirmTimer.current), []);

  if (!entry) {
    return (
      <button
        onClick={() => onEmptyClick(num, name)}
        className="w-full bg-white border-2 border-dashed border-border-dark rounded-xl aspect-[0.72] flex flex-col items-center justify-center gap-1.5 cursor-pointer hover:border-yellow transition-colors"
      >
        <span className="text-[11px] font-bold text-ink-faint">{padDex(num)}</span>
        <span className="text-xl text-border-dark leading-none">+</span>
        <span className="text-[10px] font-semibold text-ink-faint text-center px-1.5 leading-tight">{name}</span>
      </button>
    );
  }

  const startRemoveConfirm = () => {
    setConfirmingRemove(true);
    clearTimeout(confirmTimer.current);
    confirmTimer.current = setTimeout(() => setConfirmingRemove(false), 2500);
  };

  return (
    <div className="bg-white border border-border rounded-xl overflow-hidden shadow-card">
      <button onClick={startRemoveConfirm} className="block w-full relative aspect-[0.72] bg-cream-bg cursor-pointer">
        {entry.cardImage && !imgError ? (
          <img
            src={entry.cardImage}
            alt={entry.cardName}
            loading="lazy"
            onError={() => setImgError(true)}
            className="w-full h-full object-cover"
          />
        ) : (
          <span className="w-full h-full flex items-center justify-center text-[10px] font-bold text-ink-secondary text-center px-1.5">
            {entry.cardName}
          </span>
        )}
        <span className="absolute top-1 left-1 bg-navy-dark/85 text-yellow text-[9px] font-extrabold rounded px-1 py-px">
          {padDex(num)}
        </span>
      </button>
      <div className="border-t border-border px-1.5 py-1">
        {confirmingRemove ? (
          <button
            onClick={() => {
              clearTimeout(confirmTimer.current);
              setConfirmingRemove(false);
              onRemove(num);
            }}
            className="w-full text-[10px] font-bold text-brick text-center py-0.5"
          >
            Remove from binder?
          </button>
        ) : (
          <>
            <div className="text-[10px] font-bold text-navy-dark truncate">{name}</div>
            <div className="text-[9px] text-ink-muted truncate">{entry.setName}</div>
          </>
        )}
      </div>
    </div>
  );
});

DexSlot.displayName = 'DexSlot';

export default DexSlot;
